module.exports = __webpack_public_path__ + "a1ff5ea4b5043dee2773c80012448ac8.woff";


//////////////////
// WEBPACK FOOTER
// ./src/assets/segoeui.woff
// module id = 5
// module chunks = 0